module.exports = __webpack_public_path__ + "static/media/INFOG2.f44ec60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/INFOG2.png
// module id = 256
// module chunks = 0